import { useState, useEffect } from 'react'
import Navbar from '../components/layout/Navbar'
import { campaignsApi } from '../api/campaigns'
import { smsApi } from '../api/sms'
import { mailAgentsApi } from '../api/mailAgents'

const TEMPLATE_VARS = [
  '{{greeting}}', '{{company}}', '{{location}}',
  '{{rating}}', '{{reviews}}', '{{score}}', '{{contact}}'
]

const SMS_VARS = [
  '{{first_name}}', '{{company}}', '{{location}}', '{{phone}}'
]

const SOURCE_OPTIONS = [
  { value: '', label: 'All sources' },
  { value: 'Cold Outreach', label: 'Cold Outreach' },
  { value: 'Franchise', label: 'Franchise' },
  { value: 'Referral', label: 'Referral' },
  { value: 'LinkedIn', label: 'LinkedIn' },
  { value: 'Inbound', label: 'Inbound' },
  { value: 'Event', label: 'Event' },
  { value: 'Partner', label: 'Partner' },
]

const STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'qualified', label: 'Qualified' },
  { value: 'proposal', label: 'Proposal' },
  { value: 'negotiation', label: 'Negotiation' },
  { value: 'closed_lost', label: 'Closed Lost' },
  { value: 'cold', label: 'Cold' },
]

function buildEmailTemplate({
  headline, para1, para2, bullets, ctaText,
  ctaUrl = 'https://socialreputationmanager.com',
  brandName = '&#11088; Social Reputation Manager',
  brandColor = '#667eea',
  brandTagline = 'AI-Powered Review Monitoring for Google &amp; Yelp',
  brandSignatureName = 'Social Reputation Manager',
  brandWebsite = 'https://socialreputationmanager.com',
  brandWebsiteLabel = 'socialreputationmanager.com',
}) {
  const bulletRows = bullets.map(b => `
        <tr>
          <td width="30" valign="top" style="padding: 2px 0; vertical-align: top;">
            <table cellpadding="0" cellspacing="0" border="0"><tr>
              <td width="22" height="22" align="center" valign="middle" style="width: 22px; height: 22px; background-color: ${brandColor}; border-radius: 50%; color: #ffffff; font-size: 11px; font-weight: bold; font-family: Arial, sans-serif; text-align: center; line-height: 22px;">&#10003;</td>
            </tr></table>
          </td>
          <td valign="top" style="padding: 2px 0 2px 10px; font-family: Arial, sans-serif; font-size: 14px; color: #555555; line-height: 1.7; vertical-align: top;">${b}</td>
        </tr>`).join('')

  return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<title>${brandSignatureName}</title>
</head>
<body style="margin: 0; padding: 0; background-color: #f0f0f0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%;">
<table cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: #f0f0f0; min-width: 320px;">
  <tr>
    <td align="center" style="padding: 20px 10px;">
      <table cellpadding="0" cellspacing="0" border="0" width="600" style="max-width: 600px; width: 100%;">

        <!-- HEADER -->
        <tr>
          <td style="background-color: ${brandColor}; padding: 28px 40px; border-radius: 8px 8px 0 0;">
            <p style="margin: 0 0 5px 0; font-family: Arial, sans-serif; font-size: 20px; font-weight: bold; color: #ffffff; line-height: 1.3;">${brandName}</p>
            <p style="margin: 0; font-family: Arial, sans-serif; font-size: 13px; color: rgba(255,255,255,0.8); line-height: 1.4;">${brandTagline}</p>
          </td>
        </tr>

        <!-- BODY -->
        <tr>
          <td style="background-color: #ffffff; padding: 36px 40px;">
            <p style="margin: 0 0 12px 0; font-family: Arial, sans-serif; font-size: 15px; color: #1a1a1a; line-height: 1.6;">{{greeting}}</p>
            <h2 style="margin: 0 0 20px 0; font-family: Arial, sans-serif; font-size: 22px; font-weight: bold; color: #1a1a1a; line-height: 1.3;">${headline}</h2>
            <p style="margin: 0 0 16px 0; font-family: Arial, sans-serif; font-size: 15px; color: #555555; line-height: 1.7;">${para1}</p>
            <p style="margin: 0 0 24px 0; font-family: Arial, sans-serif; font-size: 15px; color: #555555; line-height: 1.7;">${para2}</p>

            <table cellpadding="0" cellspacing="0" border="0" width="100%" style="margin-bottom: 28px;">${bulletRows}
            </table>

            <table cellpadding="0" cellspacing="0" border="0" align="center" style="margin: 0 auto 36px auto;">
              <tr>
                <td align="center" style="background-color: ${brandColor}; border-radius: 6px;">
                  <a href="${ctaUrl}" style="display: inline-block; padding: 16px 40px; font-family: Arial, sans-serif; font-size: 14px; font-weight: bold; color: #ffffff; text-decoration: none;">${ctaText}</a>
                </td>
              </tr>
            </table>

            <p style="margin: 0; font-family: Arial, sans-serif; font-size: 14px; color: #555555; line-height: 1.8;">
              I'd love to show you a quick demo &mdash; no obligation.<br><br>
              Brian Menke<br>
              ${brandSignatureName}<br>
              <a href="${brandWebsite}" style="color: ${brandColor}; text-decoration: none;">${brandWebsiteLabel}</a>
            </p>
          </td>
        </tr>

        <!-- FOOTER -->
        <tr>
          <td style="background-color: #f4f4f4; padding: 20px 40px; border-top: 1px solid #e8e8e8; border-radius: 0 0 8px 8px; text-align: center;">
            <p style="margin: 0 0 8px 0; font-family: Arial, sans-serif; font-size: 12px; color: #999999; line-height: 1.5;">&copy; 2026 ${brandSignatureName} &middot; The Neural Group &middot; Phoenix, AZ</p>
            <p style="margin: 0; font-family: Arial, sans-serif; font-size: 12px; line-height: 1.5;">
              <a href="{{unsubscribe_url}}" style="color: #999999; text-decoration: underline;">Unsubscribe</a>
            </p>
          </td>
        </tr>

      </table>
    </td>
  </tr>
</table>
</body>
</html>`
}

const TEMPLATE_HIGH_SCORE = buildEmailTemplate({
  headline: "Your Google rating is strong — but vulnerable",
  para1: "I was reviewing local businesses in your area and noticed something important about {{company}}'s Google profile. With a rating like yours, you've built a reputation most companies never reach — but even strong profiles can be vulnerable if a few reviews slip through or a slow week goes unnoticed.",
  para2: "That's why we built Social Reputation Manager — so you'll always know the moment something changes, and you're never caught off guard before it impacts your visibility or turns into lost business.",
  bullets: [
    "Instant alerts the moment a new review appears on Google or Yelp",
    "AI sentiment analysis to flag reputation risks before they affect your ranking",
    "Suggested responses to keep your engagement consistent and professional",
    "24/7 monitoring so your hard-earned reputation stays protected",
  ],
  ctaText: "See your risk score →",
})

const TEMPLATE_LOW_SCORE = buildEmailTemplate({
  headline: "Your online reputation is holding you back",
  para1: "I was reviewing {{company}}'s Google presence and noticed something most owners never see. Even a small dip in your rating can push you down in local search — and that means fewer calls, fewer clicks, and fewer new customers finding you.",
  para2: "That's exactly why we built Social Reputation Manager — to help you respond faster, catch problems early, and start turning your review score around before it costs you more business.",
  bullets: [
    "Instant alerts the moment a new review is posted on Google or Yelp",
    "AI-powered sentiment analysis so you understand exactly what customers are saying",
    "Suggested responses so you can reply quickly and professionally",
    "Reputation tracking to measure your improvement over time",
  ],
  ctaText: "See your risk score →",
})

const TEMPLATE_FRANCHISE = buildEmailTemplate({
  headline: "{{company}} — your location's reputation is yours to manage",
  para1: "Managing reputation across multiple locations isn't just harder — it's a completely different challenge. One slow week, one missed review, or one frustrated customer at a single location can impact the entire brand.",
  para2: "Most reputation tools charge per location, which gets expensive fast. That's why we built Social Reputation Manager differently — one flat rate covers up to 10 of your locations, with full visibility across your entire operation.",
  bullets: [
    "Real-time Google and Yelp review monitoring for every location",
    "Instant alerts the moment any location gets a new review",
    "AI sentiment analysis so you can spot issues before they spread",
    "One dashboard to compare performance across all locations",
  ],
  ctaText: "See how it works →",
})

const TEMPLATE_FRANCHISE_LOW = buildEmailTemplate({
  headline: "Your franchise location's reviews are putting you at risk",
  para1: "I noticed your {{company}} location has been receiving some concerning reviews online. As a franchise owner, you know that your corporate franchisor monitors review scores across all locations — and a pattern of negative reviews doesn't just affect your local reputation.",
  para2: "The good news is this is fixable, and faster than you might think. Social Reputation Manager was built specifically to help franchise owners like you turn things around quickly.",
  bullets: [
    "Get instantly alerted the moment a negative review is posted on Google or Yelp",
    "Understand exactly what customers are unhappy about with AI-powered sentiment analysis",
    "Respond quickly with suggested responses so nothing slips through the cracks",
    "Start turning your review score around before it becomes a bigger problem",
  ],
  ctaText: "See how it works →",
})

const TEMPLATE_FRANCHISE_HIGH = buildEmailTemplate({
  headline: "Your {{company}} location's reputation is strong — here's how to keep it that way",
  para1: "Your {{company}} location has built a solid online reputation, and that doesn't happen by accident — it takes real effort and great service. But one bad stretch of reviews can undo months of hard work.",
  para2: "As a franchise owner, your review score is visible to everyone — your customers, your competitors, and your franchisor. Social Reputation Manager helps you stay on top of it before a problem ever develops.",
  bullets: [
    "Instant alerts the moment a new review is posted — good or bad",
    "AI sentiment analysis so you understand trends before they become problems",
    "Suggested responses to keep your engagement consistent and professional",
    "Peace of mind knowing your reputation is being monitored 24/7",
  ],
  ctaText: "See how it works →",
})

const TEMPLATE_LGSDR = buildEmailTemplate({
  headline: "Most {{industry}} businesses lose jobs they should be winning",
  para1: "It's not a quality problem — it's a response problem. Customers call while you're on a job, and if you don't get back to them within a few minutes, they move on to the next contractor.",
  para2: "LGSDR fixes that automatically. It responds to every new inquiry instantly, captures their details, and follows up with SMS and email — so you never lose a job just because you were busy.",
  bullets: [
    "Responds to customers instantly — even when you're on a ladder or under a sink",
    "Captures name, phone, service need, and location automatically",
    "Follows up with SMS and email so leads don't go cold",
    "Sends you a qualified, ready-to-book lead",
  ],
  ctaText: "See How It Works →",
  ctaUrl: "https://lgsdr.com",
  brandName: "LGSDR",
  brandColor: "#2563eb",
  brandTagline: "AI Lead Capture for Local Service Businesses",
  brandSignatureName: "LGSDR",
  brandWebsite: "https://lgsdr.com",
  brandWebsiteLabel: "lgsdr.com",
})

const SMS_TEMPLATE_DEFAULT = `Hi {{first_name}}, Brian here. A few recent Google reviews may be pulling down {{company}}'s score. Want the fastest way to fix it? Reply YES. STOP to opt out.`

const EMPTY_CAMPAIGN = {
  name: '',
  subject: "Your Google rating is strong — but vulnerable",
  body: TEMPLATE_HIGH_SCORE,
  from_name: 'Brian Menke',
  from_email: 'alerts@socialreputationmanager.com',
  score_min: 61,
  score_max: 100,
  source_filter: '',
  status_filter: '',
  mail_agent_id: null,
}

const EMPTY_SMS_CAMPAIGN = {
  name: '',
  message_template: SMS_TEMPLATE_DEFAULT,
  score_min: 0,
  score_max: 100,
}

export default function CampaignsPage() {
  const [activeTab, setActiveTab] = useState('email')

  // Email state
  const [campaigns, setCampaigns] = useState([])
  const [loading, setLoading] = useState(false)
  const [showArchived, setShowArchived] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [editing, setEditing] = useState(null)
  const [sendModal, setSendModal] = useState(null)
  const [emailsModal, setEmailsModal] = useState(null)
  const [campaignEmails, setCampaignEmails] = useState([])
  const [form, setForm] = useState(EMPTY_CAMPAIGN)
  const [sendOpts, setSendOpts] = useState({ testEmail: 'brianmenke@gmail.com', useTest: true, batchSize: 100 })
  const [eligibleData, setEligibleData] = useState({ total_eligible: 0, batch: [] })
  const [msg, setMsg] = useState(null)
  const [saving, setSaving] = useState(false)
  const [sending, setSending] = useState(false)
  const [sendProgress, setSendProgress] = useState(null)
  const [activeTemplate, setActiveTemplate] = useState('high')
  const [loadingEligible, setLoadingEligible] = useState(false)
  const [mailAgents, setMailAgents] = useState([])

  // SMS state
  const [smsCampaigns, setSmsCampaigns] = useState([])
  const [smsLoading, setSmsLoading] = useState(false)
  const [smsShowArchived, setSmsShowArchived] = useState(false)
  const [smsModalOpen, setSmsModalOpen] = useState(false)
  const [smsEditing, setSmsEditing] = useState(null)
  const [smsSendModal, setSmsSendModal] = useState(null)
  const [smsMessagesModal, setSmsMessagesModal] = useState(null)
  const [smsMessages, setSmsMessages] = useState([])
  const [smsForm, setSmsForm] = useState(EMPTY_SMS_CAMPAIGN)
  const [smsSendOpts, setSmsSendOpts] = useState({ testPhone: '14083759969', useTest: true, batchSize: 50 })
  const [smsEligibleData, setSmsEligibleData] = useState({ total_eligible: 0, batch: [] })
  const [smsSaving, setSmsSaving] = useState(false)
  const [smsSending, setSmsSending] = useState(false)
  const [smsLoadingEligible, setSmsLoadingEligible] = useState(false)
  const [smsBalance, setSmsBalance] = useState(null)

  useEffect(() => { loadCampaigns(showArchived) }, [showArchived])
  useEffect(() => { if (activeTab === 'sms') { loadSmsCampaigns(smsShowArchived); loadSmsBalance() } }, [activeTab, smsShowArchived])
  useEffect(() => { mailAgentsApi.list().then(r => setMailAgents(r.data)).catch(() => {}) }, [])

  // ─── Email functions ───────────────────────────────────────────────────────

  const loadCampaigns = async (archived = false) => {
    setLoading(true)
    try {
      const res = await campaignsApi.list(archived)
      setCampaigns(res.data)
    } catch(e) {
      setMsg({ type: 'error', text: 'Failed to load campaigns' })
    } finally {
      setLoading(false)
    }
  }

  const openAdd = () => { setForm(EMPTY_CAMPAIGN); setEditing(null); setActiveTemplate('high'); setModalOpen(true) }

  const openEdit = (c) => {
    setForm({
      name: c.name, subject: c.subject, body: c.body,
      from_name: c.from_name, from_email: c.from_email,
      score_min: c.score_min, score_max: c.score_max,
      source_filter: c.source_filter || '',
      status_filter: c.status_filter || '',
      mail_agent_id: c.mail_agent_id || null,
    })
    setEditing(c); setModalOpen(true)
  }

  const applyTemplate = (type) => {
    setActiveTemplate(type)
    if (type === 'high') {
      setForm(f => ({ ...f, body: TEMPLATE_HIGH_SCORE, subject: "Your Google rating is strong — but vulnerable", score_min: 61, score_max: 100, source_filter: '', status_filter: '' }))
    } else if (type === 'low') {
      setForm(f => ({ ...f, body: TEMPLATE_LOW_SCORE, subject: "Your online reputation is holding you back", score_min: 0, score_max: 60, source_filter: '', status_filter: '' }))
    } else if (type === 'franchise') {
      setForm(f => ({ ...f, body: TEMPLATE_FRANCHISE, subject: "{{company}} — your location's reputation is yours to manage", score_min: 0, score_max: 100, source_filter: 'Franchise', status_filter: '' }))
    } else if (type === 'franchise_low') {
      setForm(f => ({ ...f, body: TEMPLATE_FRANCHISE_LOW, subject: "Your franchise location's reviews are putting you at risk", score_min: 0, score_max: 60, source_filter: 'Franchise', status_filter: '' }))
    } else if (type === 'franchise_high') {
      setForm(f => ({ ...f, body: TEMPLATE_FRANCHISE_HIGH, subject: "Your {{company}} location's reputation is strong — here's how to keep it that way", score_min: 61, score_max: 100, source_filter: 'Franchise', status_filter: '' }))
    } else if (type === 'lgsdr') {
      setForm(f => ({ ...f, body: TEMPLATE_LGSDR, subject: "You're losing jobs you should be winning — here's the fix", score_min: 0, score_max: 100, source_filter: '', status_filter: '' }))
    }
  }

  const handleSave = async () => {
    if (!form.name || !form.subject || !form.body) { setMsg({ type: 'error', text: 'Name, subject and body are required.' }); return }
    setSaving(true)
    try {
      const payload = { ...form, source_filter: form.source_filter || null, status_filter: form.status_filter || null }
      if (editing) await campaignsApi.update(editing.id, payload)
      else await campaignsApi.create(payload)
      setModalOpen(false)
      setMsg({ type: 'success', text: editing ? 'Campaign updated.' : 'Campaign created.' })
      loadCampaigns(showArchived)
    } catch(e) {
      setMsg({ type: 'error', text: e.response?.data?.detail || 'Failed to save.' })
    } finally { setSaving(false) }
  }

  const handleArchive = async (c) => {
    if (c.is_archived) { await campaignsApi.unarchive(c.id); setMsg({ type: 'success', text: `"${c.name}" restored.` }) }
    else { await campaignsApi.archive(c.id); setMsg({ type: 'success', text: `"${c.name}" archived.` }) }
    loadCampaigns(showArchived)
  }

  const openSend = async (c) => {
    setSendModal(c); setSendOpts({ testEmail: 'brianmenke@gmail.com', useTest: true, batchSize: 100 })
    setEligibleData({ total_eligible: 0, batch: [] }); setLoadingEligible(true)
    try { const res = await campaignsApi.eligible(c.id, 100); setEligibleData(res.data) }
    catch(e) { setMsg({ type: 'error', text: 'Failed to load eligible prospects.' }) }
    finally { setLoadingEligible(false) }
  }

  const handleBatchSizeChange = async (size) => {
    const parsed = parseInt(size) || 40
    setSendOpts(o => ({ ...o, batchSize: parsed }))
    if (!sendModal) return
    setLoadingEligible(true)
    try { const res = await campaignsApi.eligible(sendModal.id, parsed); setEligibleData(res.data) }
    catch(e) {} finally { setLoadingEligible(false) }
  }

  const handleSend = async () => {
    if (eligibleData.batch.length === 0 && !sendOpts.useTest) { setMsg({ type: 'error', text: 'No eligible prospects to send to.' }); return }
    setSending(true)
    setSendProgress({ sent: 0, failed: 0, skipped: 0, total: eligibleData.batch.length })
    try {
      const testEmail = sendOpts.useTest ? sendOpts.testEmail : null
      const ids = eligibleData.batch.map(p => p.id)
      const res = await campaignsApi.send(sendModal.id, ids, testEmail)
      const { job_id } = res.data
      const campaignId = sendModal.id

      await new Promise((resolve, reject) => {
        const interval = setInterval(async () => {
          try {
            const poll = await campaignsApi.pollSend(campaignId, job_id)
            const job = poll.data
            setSendProgress({ sent: job.sent, failed: job.failed, skipped: job.skipped, total: job.total })
            if (job.status === 'done' || job.status === 'error') {
              clearInterval(interval)
              if (job.status === 'error') reject(new Error(job.error || 'Send failed.'))
              else resolve(job)
            }
          } catch(e) { clearInterval(interval); reject(e) }
        }, 2000)
      }).then(job => {
        setSendModal(null)
        setSendProgress(null)
        const firstError = job.details?.find(d => d.status === 'failed')?.error
        const errSuffix = job.failed > 0 && firstError ? ` Error: ${firstError}` : ''
        setMsg({ type: job.failed > 0 && job.sent === 0 ? 'error' : 'success', text: `Done — ${job.sent} sent, ${job.failed} failed, ${job.skipped} skipped.${sendOpts.useTest ? ' (Test mode — sent to ' + sendOpts.testEmail + ')' : ''}${errSuffix}` })
        loadCampaigns(showArchived)
      })
    } catch(e) {
      setSendProgress(null)
      setMsg({ type: 'error', text: e.message || e.response?.data?.detail || 'Send failed.' })
    } finally { setSending(false) }
  }

  const openEmails = async (c) => {
    try { const res = await campaignsApi.getEmails(c.id); setCampaignEmails(res.data); setEmailsModal(c) }
    catch(e) {}
  }

  const setF = (k, v) => setForm(f => ({ ...f, [k]: v }))

  // ─── SMS functions ─────────────────────────────────────────────────────────

  const loadSmsCampaigns = async (archived = false) => {
    setSmsLoading(true)
    try { const res = await smsApi.list(archived); setSmsCampaigns(res.data) }
    catch(e) { setMsg({ type: 'error', text: 'Failed to load SMS campaigns' }) }
    finally { setSmsLoading(false) }
  }

  const loadSmsBalance = async () => {
    try { const res = await smsApi.getBalance(); setSmsBalance(res.data) }
    catch(e) {}
  }

  const openSmsAdd = () => { setSmsForm(EMPTY_SMS_CAMPAIGN); setSmsEditing(null); setSmsModalOpen(true) }

  const openSmsEdit = (c) => {
    setSmsForm({ name: c.name, message_template: c.message_template, score_min: c.score_min, score_max: c.score_max })
    setSmsEditing(c); setSmsModalOpen(true)
  }

  const handleSmsSave = async () => {
    if (!smsForm.name || !smsForm.message_template) { setMsg({ type: 'error', text: 'Name and message are required.' }); return }
    setSmsSaving(true)
    try {
      if (smsEditing) await smsApi.update(smsEditing.id, smsForm)
      else await smsApi.create(smsForm)
      setSmsModalOpen(false)
      setMsg({ type: 'success', text: smsEditing ? 'SMS campaign updated.' : 'SMS campaign created.' })
      loadSmsCampaigns(smsShowArchived)
    } catch(e) {
      setMsg({ type: 'error', text: e.response?.data?.detail || 'Failed to save.' })
    } finally { setSmsSaving(false) }
  }

  const handleSmsArchive = async (c) => {
    if (c.is_archived) { await smsApi.unarchive(c.id); setMsg({ type: 'success', text: `"${c.name}" restored.` }) }
    else { await smsApi.archive(c.id); setMsg({ type: 'success', text: `"${c.name}" archived.` }) }
    loadSmsCampaigns(smsShowArchived)
  }

  const openSmsSend = async (c) => {
    setSmsSendModal(c); setSmsSendOpts({ testPhone: '14083759969', useTest: true, batchSize: 50 })
    setSmsEligibleData({ total_eligible: 0, batch: [] }); setSmsLoadingEligible(true)
    try { const res = await smsApi.eligible(c.id, 50); setSmsEligibleData(res.data) }
    catch(e) { setMsg({ type: 'error', text: 'Failed to load eligible prospects.' }) }
    finally { setSmsLoadingEligible(false) }
  }

  const handleSmsBatchSizeChange = async (size) => {
    const parsed = parseInt(size) || 10
    setSmsSendOpts(o => ({ ...o, batchSize: parsed }))
    if (!smsSendModal) return
    setSmsLoadingEligible(true)
    try { const res = await smsApi.eligible(smsSendModal.id, parsed); setSmsEligibleData(res.data) }
    catch(e) {} finally { setSmsLoadingEligible(false) }
  }

  const handleSmsSend = async () => {
    if (smsEligibleData.batch.length === 0 && !smsSendOpts.useTest) { setMsg({ type: 'error', text: 'No eligible prospects to send to.' }); return }
    setSmsSending(true)
    try {
      const testPhone = smsSendOpts.useTest ? smsSendOpts.testPhone : null
      const ids = smsEligibleData.batch.map(p => p.id)
      const res = await smsApi.send(smsSendModal.id, ids, testPhone)
      const { sent, failed, skipped } = res.data
      setSmsSendModal(null)
      setMsg({ type: 'success', text: `Done — ${sent} sent, ${failed} failed, ${skipped} skipped.${smsSendOpts.useTest ? ' (Test mode — sent to ' + smsSendOpts.testPhone + ')' : ''}` })
      loadSmsCampaigns(smsShowArchived)
    } catch(e) {
      setMsg({ type: 'error', text: e.response?.data?.detail || 'Send failed.' })
    } finally { setSmsSending(false) }
  }

  const openSmsMessages = async (c) => {
    try { const res = await smsApi.getMessages(c.id); setSmsMessages(res.data); setSmsMessagesModal(c) }
    catch(e) {}
  }

  const setSF = (k, v) => setSmsForm(f => ({ ...f, [k]: v }))
  const charCount = smsForm.message_template?.length || 0

  return (
    <div style={styles.root}>
      <Navbar />
      <main style={styles.main}>
        <div style={styles.pageHeader}>
          <div>
            <h1 style={styles.pageTitle}>Campaigns</h1>
            <p style={styles.pageSub}>Create personalized email and SMS campaigns targeted by lead score.</p>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <label style={{ fontSize: 13, color: '#666', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}>
              <input type="checkbox" checked={activeTab === 'email' ? showArchived : smsShowArchived}
                onChange={e => activeTab === 'email' ? setShowArchived(e.target.checked) : setSmsShowArchived(e.target.checked)} />
              Show archived
            </label>
            <button style={styles.addBtn} onClick={activeTab === 'email' ? openAdd : openSmsAdd}>
              + New {activeTab === 'email' ? 'email' : 'SMS'} campaign
            </button>
          </div>
        </div>

        {/* Tab switcher */}
        <div style={styles.tabRow}>
          <button style={{ ...styles.tab, ...(activeTab === 'email' ? styles.tabActive : {}) }} onClick={() => setActiveTab('email')}>
            📧 Email campaigns
          </button>
          <button style={{ ...styles.tab, ...(activeTab === 'sms' ? styles.tabActive : {}) }} onClick={() => setActiveTab('sms')}>
            💬 SMS campaigns
          </button>
          {activeTab === 'sms' && smsBalance && typeof smsBalance.balance !== 'undefined' && (
            <span style={styles.balanceBadge}>
              Balance: {String(smsBalance.balance)} {String(smsBalance.currency || '')}
            </span>
          )}
        </div>

        {msg && (
          <div style={msg.type === 'success' ? styles.successBanner : styles.errorBanner}>
            {msg.text}
          </div>
        )}

        {/* ── EMAIL TAB ── */}
        {activeTab === 'email' && (
          <>
            <div style={styles.varHelper}>
              <span style={styles.varLabel}>Personalization variables:</span>
              {TEMPLATE_VARS.map(v => <code key={v} style={styles.varChip}>{v}</code>)}
            </div>

            {loading ? (
              <div style={styles.empty}>Loading campaigns...</div>
            ) : campaigns.length === 0 ? (
              <div style={styles.emptyState}>
                <p style={styles.emptyTitle}>{showArchived ? 'No archived campaigns' : 'No campaigns yet'}</p>
                <p style={styles.emptySub}>{showArchived ? 'Archived campaigns will appear here.' : 'Create your first campaign to start reaching out to prospects.'}</p>
                {!showArchived && <button style={styles.addBtn} onClick={openAdd}>+ New campaign</button>}
              </div>
            ) : (
              <div style={styles.campaignList}>
                {campaigns.map(c => (
                  <div key={c.id} style={{ ...styles.campaignCard, opacity: c.is_archived ? 0.65 : 1 }}>
                    <div style={styles.cardTop}>
                      <div>
                        <div style={styles.campaignName}>
                          {c.name}
                          {c.is_archived && <span style={styles.archivedBadge}>Archived</span>}
                          {c.source_filter && <span style={styles.sourceBadge}>{c.source_filter}</span>}
                          {c.status_filter && <span style={styles.sourceBadge}>{c.status_filter}</span>}
                        </div>
                        <div style={styles.campaignSubject}>Subject: {c.subject}</div>
                        <div style={styles.campaignMeta}>
                          Score range: {c.score_min}–{c.score_max} · From: {c.from_name}
                          {c.source_filter ? ` · Source: ${c.source_filter}` : ' · All sources'}
                          {c.status_filter ? ` · Status: ${c.status_filter}` : ''}
                        </div>
                      </div>
                      <div style={styles.cardStats}>
                        <div style={styles.stat}><span style={styles.statVal}>{c.total_sent}</span><span style={styles.statLabel}>Sent</span></div>
                        <div style={styles.stat}><span style={{ ...styles.statVal, color: c.total_failed > 0 ? '#E24B4A' : '#1a1a1a' }}>{c.total_failed}</span><span style={styles.statLabel}>Failed</span></div>
                      </div>
                    </div>
                    <div style={styles.cardActions}>
                      {!c.is_archived && <button style={styles.sendBtn} onClick={() => openSend(c)}>📧 Send</button>}
                      <button style={styles.actionBtn} onClick={() => openEmails(c)}>View sent</button>
                      {!c.is_archived && <button style={styles.actionBtn} onClick={() => openEdit(c)}>Edit</button>}
                      <button style={{ ...styles.actionBtn, ...(c.is_archived ? styles.restoreBtn : styles.archiveBtn) }} onClick={() => handleArchive(c)}>
                        {c.is_archived ? 'Restore' : 'Archive'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {/* ── SMS TAB ── */}
        {activeTab === 'sms' && (
          <>
            <div style={styles.varHelper}>
              <span style={styles.varLabel}>SMS variables:</span>
              {SMS_VARS.map(v => <code key={v} style={styles.varChip}>{v}</code>)}
              <span style={{ fontSize: 11, color: '#888', marginLeft: 8 }}>Keep under 140 characters · Include "Reply STOP to opt out"</span>
            </div>

            {smsLoading ? (
              <div style={styles.empty}>Loading SMS campaigns...</div>
            ) : smsCampaigns.length === 0 ? (
              <div style={styles.emptyState}>
                <p style={styles.emptyTitle}>{smsShowArchived ? 'No archived SMS campaigns' : 'No SMS campaigns yet'}</p>
                <p style={styles.emptySub}>Create your first SMS campaign to start reaching prospects by text.</p>
                {!smsShowArchived && <button style={styles.addBtn} onClick={openSmsAdd}>+ New SMS campaign</button>}
              </div>
            ) : (
              <div style={styles.campaignList}>
                {smsCampaigns.map(c => (
                  <div key={c.id} style={{ ...styles.campaignCard, opacity: c.is_archived ? 0.65 : 1 }}>
                    <div style={styles.cardTop}>
                      <div style={{ flex: 1 }}>
                        <div style={styles.campaignName}>
                          💬 {c.name}
                          {c.is_archived && <span style={styles.archivedBadge}>Archived</span>}
                        </div>
                        <div style={{ ...styles.campaignSubject, fontFamily: 'monospace', fontSize: 12, color: '#555', marginTop: 4, maxWidth: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {c.message_template}
                        </div>
                        <div style={styles.campaignMeta}>Score range: {c.score_min}–{c.score_max}</div>
                      </div>
                      <div style={styles.cardStats}>
                        <div style={styles.stat}><span style={styles.statVal}>{c.total_sent}</span><span style={styles.statLabel}>Sent</span></div>
                        <div style={styles.stat}><span style={{ ...styles.statVal, color: c.total_replies > 0 ? '#185FA5' : '#1a1a1a' }}>{c.total_replies}</span><span style={styles.statLabel}>Replies</span></div>
                        <div style={styles.stat}><span style={{ ...styles.statVal, color: c.total_failed > 0 ? '#E24B4A' : '#1a1a1a' }}>{c.total_failed}</span><span style={styles.statLabel}>Failed</span></div>
                      </div>
                    </div>
                    <div style={styles.cardActions}>
                      {!c.is_archived && <button style={styles.smsSendBtn} onClick={() => openSmsSend(c)}>💬 Send</button>}
                      <button style={styles.actionBtn} onClick={() => openSmsMessages(c)}>View sent</button>
                      {!c.is_archived && <button style={styles.actionBtn} onClick={() => openSmsEdit(c)}>Edit</button>}
                      <button style={{ ...styles.actionBtn, ...(c.is_archived ? styles.restoreBtn : styles.archiveBtn) }} onClick={() => handleSmsArchive(c)}>
                        {c.is_archived ? 'Restore' : 'Archive'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </main>

      {/* ── EMAIL Create/Edit Modal ── */}
      {modalOpen && (
        <div style={styles.overlay} onClick={e => e.target === e.currentTarget && setModalOpen(false)}>
          <div style={styles.modal}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>{editing ? 'Edit campaign' : 'New campaign'}</h2>
              <button style={styles.closeBtn} onClick={() => setModalOpen(false)}>✕</button>
            </div>
            {!editing && (
              <div style={styles.templatePicker}>
                <span style={styles.varLabel}>Start with a template:</span>
                <button style={{ ...styles.templateBtn, ...(activeTemplate === 'high' ? styles.templateBtnActive : {}) }} onClick={() => applyTemplate('high')}>
                  ⭐ High score (61–100)
                </button>
                <button style={{ ...styles.templateBtn, ...(activeTemplate === 'low' ? styles.templateBtnActive : {}) }} onClick={() => applyTemplate('low')}>
                  📉 Low score (0–60)
                </button>
                <button style={{ ...styles.templateBtn, ...(activeTemplate === 'franchise' ? styles.templateBtnActive : {}) }} onClick={() => applyTemplate('franchise')}>
                  🏪 Franchise
                </button>
                <button style={{ ...styles.templateBtn, ...(activeTemplate === 'franchise_low' ? styles.templateBtnActive : {}) }} onClick={() => applyTemplate('franchise_low')}>
                  🏪📉 Franchise Low (0–60)
                </button>
                <button style={{ ...styles.templateBtn, ...(activeTemplate === 'franchise_high' ? styles.templateBtnActive : {}) }} onClick={() => applyTemplate('franchise_high')}>
                  🏪⭐ Franchise High (61–100)
                </button>
                <button style={{ ...styles.templateBtn, ...(activeTemplate === 'lgsdr' ? styles.templateBtnActive : {}) }} onClick={() => applyTemplate('lgsdr')}>
                  🤖 LGSDR
                </button>
              </div>
            )}
            <div style={styles.formGrid}>
              <div style={styles.formGroup}><label style={styles.label}>Campaign name *</label><input value={form.name} onChange={e => setF('name', e.target.value)} placeholder="e.g. High score outreach" /></div>
              <div style={styles.formGroup}><label style={styles.label}>From name</label><input value={form.from_name} onChange={e => setF('from_name', e.target.value)} /></div>
              <div style={styles.formGroup}><label style={styles.label}>Score min</label><input type="number" min="0" max="100" value={form.score_min} onChange={e => setF('score_min', parseInt(e.target.value)||0)} /></div>
              <div style={styles.formGroup}><label style={styles.label}>Score max</label><input type="number" min="0" max="100" value={form.score_max} onChange={e => setF('score_max', parseInt(e.target.value)||100)} /></div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Source filter</label>
                <select value={form.source_filter} onChange={e => setF('source_filter', e.target.value)} style={styles.select}>
                  {SOURCE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Status filter</label>
                <select value={form.status_filter} onChange={e => setF('status_filter', e.target.value)} style={styles.select}>
                  {STATUS_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div style={{ ...styles.formGroup, gridColumn: '1 / -1' }}>
                <label style={styles.label}>Mail agent</label>
                <select
                  value={form.mail_agent_id ?? ''}
                  onChange={e => {
                    const id = e.target.value ? parseInt(e.target.value) : null
                    const agent = mailAgents.find(a => a.id === id)
                    setForm(f => ({
                      ...f,
                      mail_agent_id: id,
                      from_name: agent ? agent.from_name : f.from_name,
                      from_email: agent ? agent.from_email : f.from_email,
                    }))
                  }}
                  style={styles.select}
                >
                  <option value="">— Use default SMTP (env vars) —</option>
                  {mailAgents.map(a => (
                    <option key={a.id} value={a.id}>{a.name} ({a.from_email})</option>
                  ))}
                </select>
              </div>
              <div style={{ ...styles.formGroup, gridColumn: '1 / -1' }}><label style={styles.label}>Email subject *</label><input value={form.subject} onChange={e => setF('subject', e.target.value)} /></div>
              <div style={{ ...styles.formGroup, gridColumn: '1 / -1' }}><label style={styles.label}>Email body (HTML) *</label><textarea value={form.body} onChange={e => setF('body', e.target.value)} style={styles.bodyTextarea} /></div>
            </div>
            <div style={styles.modalActions}>
              <button style={styles.cancelBtn} onClick={() => setModalOpen(false)}>Cancel</button>
              <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save campaign'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── SMS Create/Edit Modal ── */}
      {smsModalOpen && (
        <div style={styles.overlay} onClick={e => e.target === e.currentTarget && setSmsModalOpen(false)}>
          <div style={styles.modal}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>{smsEditing ? 'Edit SMS campaign' : 'New SMS campaign'}</h2>
              <button style={styles.closeBtn} onClick={() => setSmsModalOpen(false)}>✕</button>
            </div>
            <div style={styles.formGrid}>
              <div style={styles.formGroup}><label style={styles.label}>Campaign name *</label><input value={smsForm.name} onChange={e => setSF('name', e.target.value)} placeholder="e.g. Pest Control Outreach" /></div>
              <div style={styles.formGroup}><label style={styles.label}>Score min</label><input type="number" min="0" max="100" value={smsForm.score_min} onChange={e => setSF('score_min', parseInt(e.target.value)||0)} /></div>
              <div style={styles.formGroup}><label style={styles.label}>Score max</label><input type="number" min="0" max="100" value={smsForm.score_max} onChange={e => setSF('score_max', parseInt(e.target.value)||100)} /></div>
              <div style={{ ...styles.formGroup, gridColumn: '1 / -1' }}>
                <label style={{ ...styles.label, display: 'flex', justifyContent: 'space-between' }}>
                  <span>Message template * (include Reply STOP to opt out)</span>
                  <span style={{ color: charCount > 140 ? '#E24B4A' : '#888' }}>{charCount}/140</span>
                </label>
                <textarea value={smsForm.message_template} onChange={e => setSF('message_template', e.target.value)} style={{ ...styles.bodyTextarea, minHeight: 120, fontFamily: 'inherit', fontSize: 13 }} placeholder="Hey {{first_name}}, this is Brian..." />
              </div>
            </div>
            <div style={styles.modalActions}>
              <button style={styles.cancelBtn} onClick={() => setSmsModalOpen(false)}>Cancel</button>
              <button style={styles.saveBtn} onClick={handleSmsSave} disabled={smsSaving}>{smsSaving ? 'Saving...' : 'Save SMS campaign'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── EMAIL Send Modal ── */}
      {sendModal && (
        <div style={styles.overlay} onClick={e => e.target === e.currentTarget && setSendModal(null)}>
          <div style={{ ...styles.modal, width: 480 }}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>Send: {sendModal.name}</h2>
              <button style={styles.closeBtn} onClick={() => setSendModal(null)}>✕</button>
            </div>
            {sendModal.source_filter && (
              <div style={styles.sourceFilterNote}>🎯 Targeting: <strong>{sendModal.source_filter}</strong> only</div>
            )}
            <div style={styles.sendInfo}>
              {loadingEligible ? <div style={{ fontSize: 13, color: '#888' }}>Loading eligible prospects...</div> : (
                <div style={{ display: 'flex', gap: 24, alignItems: 'baseline' }}>
                  <div style={styles.sendStat}><span style={styles.sendStatVal}>{eligibleData.total_eligible}</span><span style={styles.sendStatLabel}>total unsent eligible</span></div>
                  <div style={styles.sendStat}><span style={{ ...styles.sendStatVal, fontSize: 20 }}>{eligibleData.batch.length}</span><span style={styles.sendStatLabel}>in this batch</span></div>
                </div>
              )}
            </div>
            <div style={{ ...styles.formGroup, marginBottom: 12 }}>
              <label style={styles.label}>Batch size</label>
              <input type="number" min="1" max="100" value={sendOpts.batchSize} onChange={e => handleBatchSizeChange(e.target.value)} style={{ width: 100 }} />
            </div>
            {!loadingEligible && eligibleData.batch.length > 0 && (
              <div style={styles.batchPreview}>
                <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Top {eligibleData.batch.length} prospects:</div>
                <div style={{ maxHeight: 150, overflowY: 'auto' }}>
                  {eligibleData.batch.map(p => (
                    <div key={p.id} style={styles.batchRow}>
                      <span style={styles.batchCompany}>{p.company}</span>
                      <span style={styles.batchScore}>{p.score}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {!loadingEligible && eligibleData.total_eligible === 0 && <div style={styles.warningBox}>No unsent eligible prospects found.</div>}
            <div style={{ ...styles.formGroup, marginTop: 12 }}>
              <label style={{ ...styles.label, display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13 }}>
                <input type="checkbox" checked={sendOpts.useTest} onChange={e => setSendOpts(o => ({ ...o, useTest: e.target.checked }))} />
                Test mode — send only to test email
              </label>
            </div>
            {sendOpts.useTest && (
              <div style={{ ...styles.formGroup, marginTop: 8 }}>
                <label style={styles.label}>Test email address</label>
                <input type="email" value={sendOpts.testEmail} onChange={e => setSendOpts(o => ({ ...o, testEmail: e.target.value }))} />
              </div>
            )}
            {!sendOpts.useTest && eligibleData.total_eligible > 0 && <div style={styles.warningBox}>⚠️ Live mode — emails will be sent to {eligibleData.batch.length} real prospects.</div>}
            {sendProgress && (
              <div style={styles.sendProgress}>
                <div style={styles.sendProgressBar}>
                  <div style={{ ...styles.sendProgressFill, width: `${sendProgress.total > 0 ? Math.round(((sendProgress.sent + sendProgress.failed + sendProgress.skipped) / sendProgress.total) * 100) : 0}%` }} />
                </div>
                <div style={styles.sendProgressStats}>
                  <span style={{ color: '#0F6E56' }}>{sendProgress.sent} sent</span>
                  {sendProgress.failed > 0 && <span style={{ color: '#991F1F' }}>{sendProgress.failed} failed</span>}
                  {sendProgress.skipped > 0 && <span style={{ color: '#888' }}>{sendProgress.skipped} skipped</span>}
                  <span style={{ color: '#aaa' }}>{sendProgress.sent + sendProgress.failed + sendProgress.skipped} / {sendProgress.total}</span>
                </div>
              </div>
            )}
            <div style={styles.modalActions}>
              <button style={styles.cancelBtn} onClick={() => setSendModal(null)} disabled={sending}>Cancel</button>
              <button style={styles.saveBtn} onClick={handleSend} disabled={sending || loadingEligible || (eligibleData.batch.length === 0 && !sendOpts.useTest)}>
                {sending ? 'Sending...' : sendOpts.useTest ? `Send test to ${sendOpts.testEmail}` : `Send to ${eligibleData.batch.length} prospects`}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── SMS Send Modal ── */}
      {smsSendModal && (
        <div style={styles.overlay} onClick={e => e.target === e.currentTarget && setSmsSendModal(null)}>
          <div style={{ ...styles.modal, width: 480 }}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>Send SMS: {smsSendModal.name}</h2>
              <button style={styles.closeBtn} onClick={() => setSmsSendModal(null)}>✕</button>
            </div>
            <div style={styles.sendInfo}>
              {smsLoadingEligible ? <div style={{ fontSize: 13, color: '#888' }}>Loading eligible prospects...</div> : (
                <div style={{ display: 'flex', gap: 24, alignItems: 'baseline' }}>
                  <div style={styles.sendStat}><span style={styles.sendStatVal}>{smsEligibleData.total_eligible}</span><span style={styles.sendStatLabel}>total unsent eligible</span></div>
                  <div style={styles.sendStat}><span style={{ ...styles.sendStatVal, fontSize: 20 }}>{smsEligibleData.batch.length}</span><span style={styles.sendStatLabel}>in this batch</span></div>
                </div>
              )}
            </div>
            <div style={{ ...styles.formGroup, marginBottom: 12 }}>
              <label style={styles.label}>Batch size (start small — 10 recommended)</label>
              <input type="number" min="1" max="100" value={smsSendOpts.batchSize} onChange={e => handleSmsBatchSizeChange(e.target.value)} style={{ width: 100 }} />
            </div>
            {!smsLoadingEligible && smsEligibleData.batch.length > 0 && (
              <div style={styles.batchPreview}>
                <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Top {smsEligibleData.batch.length} prospects:</div>
                <div style={{ maxHeight: 150, overflowY: 'auto' }}>
                  {smsEligibleData.batch.map(p => (
                    <div key={p.id} style={styles.batchRow}>
                      <span style={styles.batchCompany}>{p.company}</span>
                      <span style={{ ...styles.batchScore, fontFamily: 'monospace' }}>{p.phone}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {!smsLoadingEligible && smsEligibleData.total_eligible === 0 && <div style={styles.warningBox}>No unsent eligible prospects with phone numbers found.</div>}
            <div style={{ ...styles.formGroup, marginTop: 12 }}>
              <label style={{ ...styles.label, display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13 }}>
                <input type="checkbox" checked={smsSendOpts.useTest} onChange={e => setSmsSendOpts(o => ({ ...o, useTest: e.target.checked }))} />
                Test mode — send only to test phone
              </label>
            </div>
            {smsSendOpts.useTest && (
              <div style={{ ...styles.formGroup, marginTop: 8 }}>
                <label style={styles.label}>Test phone number</label>
                <input type="tel" value={smsSendOpts.testPhone} onChange={e => setSmsSendOpts(o => ({ ...o, testPhone: e.target.value }))} />
              </div>
            )}
            {!smsSendOpts.useTest && smsEligibleData.total_eligible > 0 && <div style={styles.warningBox}>⚠️ Live mode — texts will be sent to {smsEligibleData.batch.length} real prospects.</div>}
            <div style={styles.modalActions}>
              <button style={styles.cancelBtn} onClick={() => setSmsSendModal(null)}>Cancel</button>
              <button style={styles.saveBtn} onClick={handleSmsSend} disabled={smsSending || smsLoadingEligible || (smsEligibleData.batch.length === 0 && !smsSendOpts.useTest)}>
                {smsSending ? 'Sending...' : smsSendOpts.useTest ? `Send test to ${smsSendOpts.testPhone}` : `Send to ${smsEligibleData.batch.length} prospects`}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── EMAIL Sent Emails Modal ── */}
      {emailsModal && (
        <div style={styles.overlay} onClick={e => e.target === e.currentTarget && setEmailsModal(null)}>
          <div style={{ ...styles.modal, width: 640 }}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>Sent emails: {emailsModal.name}</h2>
              <button style={styles.closeBtn} onClick={() => setEmailsModal(null)}>✕</button>
            </div>
            {campaignEmails.length === 0 ? <p style={{ color: '#888', fontSize: 13 }}>No emails sent yet.</p> : (
              <div style={{ overflowY: 'auto', maxHeight: 400 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead><tr>{['To', 'Email', 'Status', 'Sent at'].map(h => <th key={h} style={{ textAlign: 'left', padding: '6px 10px', borderBottom: '0.5px solid #e0dfd8', fontSize: 11, color: '#888' }}>{h}</th>)}</tr></thead>
                  <tbody>
                    {campaignEmails.map(e => (
                      <tr key={e.id}>
                        <td style={{ padding: '8px 10px', borderBottom: '0.5px solid #f0efe8' }}>{e.to_name}</td>
                        <td style={{ padding: '8px 10px', borderBottom: '0.5px solid #f0efe8', color: '#185FA5' }}>{e.to_email}</td>
                        <td style={{ padding: '8px 10px', borderBottom: '0.5px solid #f0efe8' }}>
                          <span style={{ background: e.status === 'Sent' ? '#EAF3DE' : '#FCEBEB', color: e.status === 'Sent' ? '#27500A' : '#791F1F', padding: '2px 8px', borderRadius: 20, fontSize: 11 }}>{e.status}</span>
                        </td>
                        <td style={{ padding: '8px 10px', borderBottom: '0.5px solid #f0efe8', fontSize: 12, color: '#888' }}>{e.sent_at ? new Date(e.sent_at).toLocaleString() : '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── SMS Messages Modal ── */}
      {smsMessagesModal && (
        <div style={styles.overlay} onClick={e => e.target === e.currentTarget && setSmsMessagesModal(null)}>
          <div style={{ ...styles.modal, width: 700 }}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>SMS messages: {smsMessagesModal.name}</h2>
              <button style={styles.closeBtn} onClick={() => setSmsMessagesModal(null)}>✕</button>
            </div>
            {smsMessages.length === 0 ? <p style={{ color: '#888', fontSize: 13 }}>No messages sent yet.</p> : (
              <div style={{ overflowY: 'auto', maxHeight: 450 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr>
                      {['Company', 'Phone', 'Status', 'Reply', 'Sent at'].map(h => (
                        <th key={h} style={{ textAlign: 'left', padding: '6px 10px', borderBottom: '0.5px solid #e0dfd8', fontSize: 11, color: '#888' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {smsMessages.map(m => (
                      <tr key={m.id}>
                        <td style={{ padding: '8px 10px', borderBottom: '0.5px solid #f0efe8', fontWeight: 500 }}>{m.company}</td>
                        <td style={{ padding: '8px 10px', borderBottom: '0.5px solid #f0efe8', fontFamily: 'monospace', fontSize: 12 }}>{m.phone}</td>
                        <td style={{ padding: '8px 10px', borderBottom: '0.5px solid #f0efe8' }}>
                          <span style={{ background: m.status === 'sent' ? '#EAF3DE' : '#FCEBEB', color: m.status === 'sent' ? '#27500A' : '#791F1F', padding: '2px 8px', borderRadius: 20, fontSize: 11 }}>{m.status}</span>
                        </td>
                        <td style={{ padding: '8px 10px', borderBottom: '0.5px solid #f0efe8', fontSize: 12 }}>
                          {m.reply_text ? (
                            <span>
                              <span style={{ background: m.reply_type === 'interested' ? '#EAF3DE' : m.reply_type === 'stop' ? '#FCEBEB' : '#F1EFE8', color: m.reply_type === 'interested' ? '#27500A' : m.reply_type === 'stop' ? '#791F1F' : '#5F5E5A', padding: '1px 6px', borderRadius: 10, fontSize: 10, marginRight: 4 }}>{m.reply_type}</span>
                              {m.reply_text}
                            </span>
                          ) : <span style={{ color: '#ccc' }}>—</span>}
                        </td>
                        <td style={{ padding: '8px 10px', borderBottom: '0.5px solid #f0efe8', fontSize: 12, color: '#888' }}>{m.sent_at ? new Date(m.sent_at).toLocaleString() : '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

const styles = {
  root: { minHeight: '100vh', background: '#f5f5f3' },
  main: { maxWidth: 900, margin: '0 auto', padding: '1.5rem' },
  pageHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' },
  pageTitle: { fontSize: 22, fontWeight: 500, color: '#1a1a1a', marginBottom: 4 },
  pageSub: { fontSize: 14, color: '#888' },
  addBtn: { background: '#1a1a1a', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
  tabRow: { display: 'flex', alignItems: 'center', gap: 4, marginBottom: '1rem', borderBottom: '0.5px solid #e0dfd8', paddingBottom: 0 },
  tab: { background: 'none', border: 'none', borderBottom: '2px solid transparent', padding: '8px 16px', fontSize: 13, cursor: 'pointer', color: '#888', fontWeight: 400, marginBottom: -1 },
  tabActive: { color: '#1a1a1a', fontWeight: 500, borderBottomColor: '#1a1a1a' },
  balanceBadge: { marginLeft: 'auto', fontSize: 12, color: '#0F6E56', background: '#EAF3DE', border: '0.5px solid #C0DD97', borderRadius: 20, padding: '3px 10px' },
  successBanner: { background: '#EAF3DE', color: '#27500A', border: '0.5px solid #C0DD97', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: '1rem' },
  errorBanner: { background: '#FCEBEB', color: '#791F1F', border: '0.5px solid #F09595', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: '1rem' },
  varHelper: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: '1rem', padding: '10px 14px', background: '#fff', border: '0.5px solid #e0dfd8', borderRadius: 8 },
  varLabel: { fontSize: 12, color: '#888', whiteSpace: 'nowrap' },
  varChip: { background: '#f5f5f3', border: '0.5px solid #e0dfd8', borderRadius: 4, padding: '2px 6px', fontSize: 11, fontFamily: 'monospace', color: '#185FA5' },
  templatePicker: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: '1rem', padding: '10px 14px', background: '#f5f5f3', borderRadius: 8 },
  templateBtn: { background: '#fff', border: '0.5px solid #ccc', borderRadius: 8, padding: '6px 14px', fontSize: 12, cursor: 'pointer', color: '#444' },
  templateBtnActive: { background: '#1a1a1a', color: '#fff', borderColor: '#1a1a1a' },
  sourceBadge: { fontSize: 11, background: '#FFF7ED', color: '#9A3412', border: '0.5px solid #FDB073', padding: '2px 8px', borderRadius: 20, fontWeight: 400 },
  sourceFilterNote: { background: '#FFF7ED', color: '#9A3412', border: '0.5px solid #FDB073', borderRadius: 8, padding: '8px 12px', fontSize: 13, marginBottom: 12 },
  campaignList: { display: 'flex', flexDirection: 'column', gap: 12 },
  campaignCard: { background: '#fff', border: '0.5px solid #e0dfd8', borderRadius: 12, padding: '1.25rem' },
  cardTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' },
  campaignName: { fontSize: 16, fontWeight: 500, color: '#1a1a1a', marginBottom: 4, display: 'flex', alignItems: 'center', gap: 8 },
  archivedBadge: { fontSize: 11, background: '#F1EFE8', color: '#5F5E5A', padding: '2px 8px', borderRadius: 20, fontWeight: 400 },
  campaignSubject: { fontSize: 13, color: '#444', marginBottom: 4 },
  campaignMeta: { fontSize: 12, color: '#888' },
  cardStats: { display: 'flex', gap: 20 },
  stat: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
  statVal: { fontSize: 22, fontWeight: 500, color: '#1a1a1a' },
  statLabel: { fontSize: 11, color: '#888' },
  cardActions: { display: 'flex', gap: 8, borderTop: '0.5px solid #e0dfd8', paddingTop: '1rem' },
  sendBtn: { background: '#1a1a1a', color: '#fff', border: 'none', borderRadius: 8, padding: '7px 16px', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
  smsSendBtn: { background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, padding: '7px 16px', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
  actionBtn: { background: 'none', border: '0.5px solid #ccc', borderRadius: 8, padding: '7px 14px', fontSize: 13, cursor: 'pointer', color: '#444' },
  archiveBtn: { borderColor: '#D3D1C7', color: '#5F5E5A' },
  restoreBtn: { borderColor: '#9FE1CB', color: '#0F6E56' },
  emptyState: { textAlign: 'center', padding: '4rem 2rem' },
  emptyTitle: { fontSize: 16, fontWeight: 500, color: '#1a1a1a', marginBottom: 6 },
  emptySub: { fontSize: 14, color: '#888', marginBottom: '1.5rem' },
  empty: { textAlign: 'center', padding: '2rem', color: '#888' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 },
  modal: { background: '#fff', borderRadius: 16, border: '0.5px solid #e0dfd8', padding: '1.5rem', width: 620, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' },
  modalTitle: { fontSize: 16, fontWeight: 500, color: '#1a1a1a' },
  closeBtn: { background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', color: '#888' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 },
  formGroup: { display: 'flex', flexDirection: 'column', gap: 4 },
  label: { fontSize: 11, color: '#666' },
  select: { padding: '8px 10px', fontSize: 13, border: '0.5px solid #ccc', borderRadius: 8, background: '#fff', fontFamily: 'inherit' },
  bodyTextarea: { resize: 'vertical', minHeight: 220, padding: 8, fontFamily: 'monospace', fontSize: 12, border: '0.5px solid #ccc', borderRadius: 8, outline: 'none', width: '100%', boxSizing: 'border-box' },
  modalActions: { display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: '1.25rem' },
  cancelBtn: { background: 'none', border: '0.5px solid #ccc', borderRadius: 8, padding: '8px 16px', fontSize: 13, cursor: 'pointer', color: '#444' },
  saveBtn: { background: '#1a1a1a', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
  sendInfo: { background: '#f5f5f3', borderRadius: 8, padding: '12px 14px', marginBottom: '1rem' },
  sendStat: { display: 'flex', alignItems: 'baseline', gap: 6 },
  sendStatVal: { fontSize: 28, fontWeight: 500, color: '#1a1a1a' },
  sendStatLabel: { fontSize: 13, color: '#666' },
  warningBox: { background: '#FAEEDA', color: '#633806', border: '0.5px solid #FAC775', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: '1rem' },
  batchPreview: { background: '#f9f9f7', border: '0.5px solid #e0dfd8', borderRadius: 8, padding: '10px 12px', marginBottom: 12 },
  batchRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '0.5px solid #f0efe8' },
  batchCompany: { fontSize: 12, color: '#1a1a1a' },
  batchScore: { fontSize: 11, color: '#888', background: '#f0efe8', padding: '1px 6px', borderRadius: 10 },
  sendProgress: { marginBottom: 12 },
  sendProgressBar: { height: 6, background: '#e0dfd8', borderRadius: 3, overflow: 'hidden', marginBottom: 6 },
  sendProgressFill: { height: '100%', background: '#0F6E56', borderRadius: 3, transition: 'width 0.4s ease' },
  sendProgressStats: { display: 'flex', gap: 12, fontSize: 12 },
}